<div class="product-card-price">
  @if (shouldDisplayPrices) {
    @if (isLoading == true) {
      <app-loading-indicator-base [loadingIndicatorStyle]="eLoadingIndicatorStyle.EMBEDDED"></app-loading-indicator-base>
    }
    @if (isLoading != true) {
      @if (priceTemplateData != undefined) {
        @if (priceTemplateData.orderPriceMark != undefined && priceTemplateData.orderPriceMark == ePriceMark.NoPrice) {
          <app-no-valid-price></app-no-valid-price>
        }

        @if (priceTemplateData.orderPriceMark == undefined || priceTemplateData.orderPriceMark != ePriceMark.NoPrice) {
          @if (priceTemplateData.orderPriceType != undefined) {
            @if (priceTemplateData.orderPriceIsUnitPrice == true) {
              <app-price-format [priceFormat]="priceTemplateData.orderUnitPrice" [displayPriceWithoutDiscountsUponDiscounts]="true" [shouldDisplayDeposit]="true" [shouldDisplayBasePrice]="false" [shouldAllowTextWrap]="shouldAllowTextWrap">
              </app-price-format>
            }
            @if (priceTemplateData.orderPriceIsUnitPrice != true) {
              <app-price-format
                [priceFormat]="priceTemplateData.orderPricePerPriceQuantity"
                [displayPriceWithoutDiscountsUponDiscounts]="true"
                [shouldDisplayDeposit]="true"
                [shouldDisplayBasePrice]="false"
                [shouldAllowTextWrap]="shouldAllowTextWrap"
              >
              </app-price-format>
            }
          }
        }
      }
    }
  }

  @if (!shouldDisplayPrices) {
    <app-price-missing-info-icon></app-price-missing-info-icon>
  }
</div>
